<div class="table-specific-settings-wrapper" [formGroup]="form">
  <div class="table-specific-settings-title">
    <y42-sub-navigation [isBig]="true" [navigationType]="navigationType"> </y42-sub-navigation>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Separator</mat-label>
      <mat-select cdkFocusInitial [formControlName]="csvOptionsPropertyNames.field_delimiter">
        <mat-option *ngFor="let operator of fieldDelimiterTypes; trackBy: trackByValue" value="{{ operator.value }}"
          >{{ operator.title }} {{ operator.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div>The separator for fields in a CSV file.</div>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Header Rows (Optional)</mat-label>
      <input matInput [formControlName]="csvOptionsPropertyNames.skip_leading_rows" type="number" autocomplete="off" />
    </mat-form-field>
    <div>Indicating the number of header rows in the source data.</div>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Null Value Marker (Optional)</mat-label>
      <input matInput [formControlName]="csvOptionsPropertyNames.null_marker" type="text" autocomplete="off" />
    </mat-form-field>
    <div>
      Specifies a string that represents a null value in a CSV file. For example, if you specify
      <span class="text-red-600">\N</span>, Y42 interprets <span class="text-red-600">\N</span> as a null value when
      loading a CSV file. The default value is the empty string.
    </div>
  </div>
  <div class="table-settings-section section-halved">
    <div class="aligner-start">
      <mat-slide-toggle color="primary" [formControlName]="csvOptionsPropertyNames.allow_quoted_new_lines">
        <span class="fs-08">Enable Quoted New Lines</span>
      </mat-slide-toggle>
    </div>
    <div>Indicates whether to allow quoted data sections that contain newline characters in a CSV file.</div>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Quote</mat-label>
      <input matInput [formControlName]="csvOptionsPropertyNames.quote" type="text" autocomplete="off" />
    </mat-form-field>
    <div>
      The value that is used to quote data sections in a CSV file. Y42 converts the string to ISO-8859-1 encoding, and
      then uses the first byte of the encoded string to split the data in its raw, binary state. The default value is a
      double-quote <span class="text-red-600">"</span>. If your data does not contain quoted sections, set the property
      value to an empty string. If your data contains quoted newline characters, you must also set the
      <b>Enable Quoted New Lines</b> property to true. To include the specific quote character within a quoted value,
      precede it with an additional matching quote character. For example, if you want to escape the default character
      <span class="text-red-600">"</span>, use <span class="text-red-600">""</span>.
    </div>
  </div>
  <div class="table-settings-section section-halved">
    <mat-form-field appearance="outline">
      <mat-label>Encoding</mat-label>
      <mat-select [formControlName]="csvOptionsPropertyNames.encoding">
        <mat-option value="UTF-8">UTF-8 </mat-option>
        <mat-option value="ISO-8859-1">ISO-8859-1 </mat-option>
      </mat-select>
    </mat-form-field>
    <div>The character encoding of the data.</div>
  </div>
</div>
